import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import { errorTypes } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

const RegionsSelectedNotSupportedAlert = ({ errors }) => {
  const { t } = useTranslation()
  const errorsToCheck = [errorTypes.invalidRegionForCarrierService, errorTypes.invalidLocationForCarrierService]

  const hasNotSupportedError = errors?.some(error => errorsToCheck.includes(error.type))

  if (!hasNotSupportedError) {
    return null
  }

  return (
    <Alert type="error">{t('Las regiones seleccionadas no son compatibles con el servicio logístico elegido.')}</Alert>
  )
}

export default RegionsSelectedNotSupportedAlert
